<template>
  <div class="slide" :style="'background-image: url(\'' + require('@/assets/images/trash/banner2.jpg') + '\');'">
    <div class="title">Два горячих блюда<br/>или салат на выбор</div>
    <div class="gift">в подарок</div>
    <div class="description">При заказе от&nbsp;1000 ₽ Вы можете выбрать «Цезарь с курицей гриль»,<br v-if="!isSmartphone"/><template v-else> </template>от&nbsp;1300 ₽ «Пирог по-осетински» и от&nbsp;1500 ₽ «Люля-кебаб из телятины»</div>
  </div>
</template>

<script>
  export default {
    name: 'SlideGen',
    components: {
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/assets/styles/core_variables";

  @font-face {
    font-family: 'Pacifico';
    src: local('Pacifico Regular'),
      local('Pacifico-Regular'),
      url($static-path + '/fonts/Pacificoregular.woff2') format('woff2'),
      url($static-path + '/fonts/Pacificoregular.woff') format('woff'),
      url($static-path + '/fonts/Pacificoregular.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Montserrat';
    src: url($static-path + '/fonts/Montserrat-Medium.eot');
    src: url($static-path + '/fonts/Montserrat-Medium.eot?#iefix') format('embedded-opentype'),
      url($static-path + '/fonts/Montserrat-Medium.woff') format('woff'),
      url($static-path + '/fonts/Montserrat-Medium.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  /*@font-face {
    font-family: 'Montserrat';
    src: local('Montserrat'),
      local('Montserrat-Regular'),
      url($static-path + '/fonts/montserrat.woff2') format('woff2'),
      url($static-path + '/fonts/montserrat.woff') format('woff'),
      url($static-path + '/fonts/montserrat.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
  }*/

  .slide {
    font-size: 100px;
    width: 11.25em;
    height: 4.4em;
    background-size: cover;
    background-position: center center;
    position: relative;

    .title {
      position: absolute;
      font-size: 0.46em;
      font-weight: 800;
      letter-spacing: -1.11px;
      color: #ffffff;
      background-color: #f54a0b;
      display: table;
      padding-bottom: (0.09/0.46)+em;
      padding-left: 0.6em;
      padding-right: 0.7em;
      text-align: right;
      clip-path: polygon(3% 0, 100% 0, 97% 53%, 96.6% 53%, 93.9% 100%, 2% 100%, 5% 53%, 0 53%);
      top: (0.58/0.46)+em;
      left: (0.905/0.46)+em;
    }

    .gift {
      font-family: 'Pacifico';
      font-size: 1em;
      letter-spacing: -0.0241em;
      color: #f9f9f9;
      left: 0.76em;
      top: 1.44em;
      position: absolute;
    }

    .description {
      position: absolute;
      font-family: 'Montserrat';
      font-size: 0.14em;
      font-weight: 400;
      line-height: 1.79;
      letter-spacing: -0.0034em;
      color: #ffffff;
      top: (3.54/0.14)+em;
      left: (0.75/0.14)+em;
    }
  }

  html.smartphone {
    .slide {
      width: 3.2em;
      height: 2.55em;

      .title {
        font-size: 0.2em;
        letter-spacing: -0.39px;
        padding-bottom: 0.06rem;
        padding-top: 0.03rem;
        padding-left: 0.12rem;
        padding-right: 0.1rem;
        clip-path: polygon(3% 0,100% 0,97% 53%,99.6% 53%, 96.9% 100%,2% 100%,5% 53%,0 53%);
        top: 0.2rem;
        left: 0.2rem;
      }

      .gift {
        font-size: 0.44em;
        letter-spacing: -0.82px;
        left: 0.18rem;
        top: 0.7rem;
      }

      .description {
        font-size: 0.11em;
        line-height: 1.25;
        letter-spacing: -0.29px;
        top: 1.9rem;
        left: 0.15rem;
        width: 2rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/tech/SlideGen.vue